import { DateTime } from 'luxon';

export function isAllowedPreviousDate(
  date: string,
  isIncludeToday: boolean = false
): boolean {
  return (
    DateTime.fromISO(date) <=
    (isIncludeToday ? DateTime.now() : DateTime.now().minus({ day: 1 }))
  );
}
